import type { PoiHighlightInput } from '../../../utils/helpers/PoiToHikeHighlightHelper';
import { poiStageDestination, type PoiStageDestination } from '../../map_data_poi_dialog/helpers/poiStageDestination';

interface RenderedFeatureLike {
  source?: string;
  geometry?: { type?: string; coordinates?: any };
  properties?: Record<string, any> | null;
}

/**
 * The map POI under the cursor, in the shape poiToHikeHighlight takes — the same
 * POI tile features a left click opens the POI sheet for (any source carrying
 * "poi", bar the hover dot). Null when there isn't one.
 */
export function poiHighlightInputAtPoint(
  features: RenderedFeatureLike[] | null | undefined,
  lngLat: { lng: number; lat: number }
): PoiHighlightInput | null {
  const feature = (features || []).find(f =>
    !!f.source && f.source !== 'hover-point' && f.source.includes('poi') && !!f.properties
  );
  if (!feature) return null;

  const { id, type, category_type: categoryType, name } = feature.properties as Record<string, any>;
  const poiType = type || categoryType;
  if (!poiType) return null;

  const [lng, lat] = feature.geometry?.type === 'Point' && Array.isArray(feature.geometry.coordinates)
    ? feature.geometry.coordinates
    : [lngLat.lng, lngLat.lat];

  return { type: poiType, name: name || '', serpName: null, description: '', lng, lat, poiClass: categoryType ?? null, poiId: id ?? null };
}

/**
 * The map POI under the cursor as a stage destination — what "Add to route"
 * attaches the route's end to, as the POI sheet does. Null when there isn't one.
 */
export function poiDestinationAtPoint(
  features: RenderedFeatureLike[] | null | undefined,
  lngLat: { lng: number; lat: number }
): PoiStageDestination | null {
  const feature = (features || []).find(f =>
    !!f.source && f.source !== 'hover-point' && f.source.includes('poi') && !!f.properties
  );
  if (!feature) return null;
  const { id, type, category_type: categoryType, name } = feature.properties as Record<string, any>;
  const at = poiHighlightInputAtPoint([feature], lngLat);
  if (!at || id == null) return null;
  return poiStageDestination({ poiType: categoryType, type: type || categoryType, poiId: id, name, lngLat: { lng: at.lng, lat: at.lat } });
}
